import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import { TextField } from '@material-ui/core';


const styles = theme => ({
  whatIsThisButton: {
    textTransform: 'none',
  },
  link: {
    display: 'inline-block',
    padding: theme.spacing.unit,
    margin: `${theme.spacing.unit}px auto`,
  },
  signatureContainer: {
    margin: `${theme.spacing.unit * 2}px 0`,
    display: 'flex',
    alignItems: 'center',
  },
  red: {
    color: '#E91E63',
  },
  listItem: {
    marginBottom: theme.spacing.unit * 2,
  },
});


class TermsAndConditions extends React.Component {

  state = {
    electronicSignatureDetail: false,
  }


  toggleElectronicSignatureDetail = () => {
    this.setState({electronicSignatureDetail: !this.state.electronicSignatureDetail})
  }


  render = () => {
    const { electronicSignatureDetail } = this.state
    const { classes, data, actions, showErrors } = this.props;

    const { terms } = data
    const { _errors, agreedToTerms, electronicSignature } = terms

    const isLegacyPricing = data.pricingMode && data.pricingMode === 'Legacy'

    const termsUrl = (
      isLegacyPricing
      ? 'https://www.coolfront.com/booksterms/'
      : 'https://fieldedge.com/legal/'
    )

    const privacyUrl = (
      isLegacyPricing
      ? 'https://www.coolfront.com/booksprivacy-policy/'
      : 'https://fieldedge.com/privacy-policy/'
    )

    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Terms and Privacy
        </Typography>

        <Typography variant="body1" component="div">
          Please read the
          <a href={termsUrl} target="_blank" rel="noopener noreferrer" className={classes.link}>
            Terms and Conditions
          </a>
          and
          <a href={privacyUrl} target="_blank" rel="noopener noreferrer" className={classes.link}>
            Privacy Policy
          </a>
          before signing.
        </Typography>

        <div className={classes.signatureContainer}>
          <TextField
            id="electronicSignature"
            name="electronicSignature"
            variant="outlined"
            required
            error={showErrors && !!_errors.electronicSignature}
            fullWidth
            label="Electronic Signature"
            autoComplete="none"
            value={electronicSignature}
            onChange={e => actions.updateElectronicSignature(e.target.value)}
          />
          <Button onClick={this.toggleElectronicSignatureDetail} color="primary" className={classes.whatIsThisButton}>
              What is an electronic signature?
          </Button>
        </div>

        <Dialog open={electronicSignatureDetail} onClose={this.toggleElectronicSignatureDetail}>
          <DialogTitle>
            Electronic Signature
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1" component="div">
              According to the Government Paperwork Elimination Act, the term 'electronic signature' means a method of signing an electronic message that:
              <ol type="A">
                <li className={classes.listItem}>identifies and authenticates a particular person as the source of the electronic message; and</li>
                <li className={classes.listItem}>indicates such person&apos;s approval of the information contained in the electronic message.</li>
              </ol>
            </Typography>
          </DialogContent>
          <DialogActions style={{padding: '1em'}}>
            <Button onClick={this.toggleElectronicSignatureDetail} variant="contained" color="primary" autoFocus>
              Got It
            </Button>
          </DialogActions>
        </Dialog>

        <FormControlLabel label="I am authorized to enter into this agreement on behalf of my company, and I accept the terms and conditions." control={
          <Checkbox
            checked={agreedToTerms}
            onChange={e => {actions.setAgreementToTerms(e.target.checked)}}
            className={(showErrors && !agreedToTerms) ? classes.red : ''}
          />
        }/>

      </React.Fragment>
    );
  }
}

TermsAndConditions.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  pricingMode: PropTypes.string,
};

export default withStyles(styles)(TermsAndConditions);